<span class="draft-ready-badge">
  <mat-icon
    class="draft-ready-badge-icon"
    svgIcon="galaxy-ai-icon-monochrome"
    [attr.aria-label]="'INBOX.CHAT.AI_DRAFT.DRAFT_READY' | translate"
  />
  <span class="draft-ready-badge-text">{{ 'INBOX.CHAT.AI_DRAFT.DRAFT_READY' | translate }}</span>
</span>
